import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class FiscalPeriodsService {
  getPropertyOpenFiscalPeriod(
    propertyId: string,
    organizationId: string,
    options: Object = {},
  ) {
    const requestOptions = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      ...options,
    };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/financialPeriods/open`,
      requestOptions,
    );
  }
}

export default FiscalPeriodsService;
